export const destinations = [
{
  name: "Bali",
  description: "Cliffside resorts, sacred temples, and romantic sunsets.",
  image:
  "https://images.unsplash.com/photo-1567491634123-460945ea86dd?auto=format&fit=crop&w=1200&q=80"
},
{
  name: "Maldives",
  description: "Overwater villas and crystal lagoons for serene luxury escapes.",
  image:
  "https://images.unsplash.com/photo-1620483829214-642f1cf68117?auto=format&fit=crop&w=1200&q=80"
},
{
  name: "Thailand",
  description: "Island-hopping adventures and vibrant culture with curated comforts.",
  image:
  "https://images.unsplash.com/photo-1736753399626-578b167b85b7?auto=format&fit=crop&w=1200&q=80"
},
{
  name: "Dubai",
  description: "Skyline glamour, desert experiences, and elite hospitality.",
  image:
  "https://images.unsplash.com/photo-1748373452031-ee1ae4eb624d?auto=format&fit=crop&w=1200&q=80"
},
{
  name: "Europe",
  description: "Multi-city journeys across iconic capitals and hidden gems.",
  image:
  "https://images.unsplash.com/photo-1606577503522-2487b09dd18f?auto=format&fit=crop&w=1200&q=80"
},
{
  name: "Vietnam",
  description: "Scenic bays, heritage towns, and immersive culinary trails.",
  image:
  "https://images.unsplash.com/photo-1725335740307-7e226e9e4fae?auto=format&fit=crop&w=1200&q=80"
}];


export const packagesData = [
{
  title: "Bali Honeymoon Escape",
  duration: "6 Nights / 7 Days",
  priceRange: "INR 62999/- Flights Included",
  highlights: ["Private villa with pool", "Couple spa ritual", "Sunset dinner cruise"],
  image:
  "https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?auto=format&fit=crop&w=1200&q=80"
},
{
  title: "Maldives Luxury Retreat",
  duration: "3 Nights / 4 Days",
  priceRange: "INR 69000",
  highlights: ["Overwater suite", "Seaplane transfers", "All-inclusive gourmet meals"],
  image:
  "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=1200&q=80"
},
{
  title: "Thailand Island Luxe",
  duration: "4 Nights / 5 Days",
  priceRange: "INR 40000",
  highlights: ["Phi Phi private boat", "Luxury beach resort", "Curated nightlife"],
  image:
  "https://images.unsplash.com/photo-1528181304800-259b08848526?auto=format&fit=crop&w=1200&q=80"
},
{
  title: "Dubai Premium Discovery",
  duration: "4 Nights / 5 Days",
  priceRange: "INR 60000",
  highlights: ["Burj Khalifa access", "Desert safari with dinner", "Marina yacht evening"],
  image:
  "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80"
}];


export const liveDealsData = [
{
  title: "International Holiday Packages",
  seats: "Custom packages available now",
  route: "Dubai • Singapore • Maldives • Bali • Vietnam • Thailand",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/bee404d02932a554_WhatsApp%20Image%202026-10-22%20at%2014.49.22.jpeg"
},
{
  title: "Escape to Bali",
  seats: "Seats available: Jan, Feb, March 2027",
  route: "Ex Delhi",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/319ff93bbf918478_WhatsApp%20Image%202026-10-22%20at%2015.04.27.jpeg"
},
{
  title: "Kerala Getaway",
  seats: "Seats available: Nov & Dec 2026",
  route: "Ex Delhi",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/2e95eb2d44b68d75_WhatsApp%20Image%202026-10-22%20at%2015.04.27%20%282%29.jpeg"
},
{
  title: "Krabi & Phuket",
  seats: "Seats available: Nov'26, Jan'27, Feb'27, March'27",
  route: "Ex Delhi",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/bbf8d08b0b0c63f4_WhatsApp%20Image%202026-10-22%20at%2015.04.27%20%281%29.jpeg"
},
{
  title: "Pattaya Bangkok",
  seats: "Seats available: 17th Nov 2026",
  route: "Ex Delhi",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/dc1d585540ca4924_WhatsApp%20Image%202026-10-22%20at%2015.04.26.jpeg"
},
{
  title: "Dubai — Best Deals Guaranteed",
  seats: "Premium departures open now",
  route: "Dubai City of Wonders",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/0d0f0a77d7821b3f_WhatsApp%20Image%202026-10-22%20at%2014.49.21.jpeg"
},
{
  title: "Vietnam Getaway with Day Cruise",
  seats: "Departure dates: 11th & 18th October",
  route: "Ex Bombay",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/605deb65c99fc7fb_WhatsApp%20Image%202026-10-22%20at%2014.49.22%20%281%29.jpeg"
},
{
  title: "Thailand Special",
  seats: "Seats: Oct'26, Nov'26, Dec'26, Jan'27",
  route: "Ex Bombay",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/08f712bf58441c65_WhatsApp%20Image%202026-10-22%20at%2014.49.21%20%282%29.jpeg"
},
{
  title: "Habibi! It's Time for Dubai",
  seats: "Limited luxury slots available",
  route: "Dubai city experiences",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/c76a1740cab53c57_WhatsApp%20Image%202026-10-22%20at%2014.49.20.jpeg"
},
{
  title: "Vietnam — Timeless Beauty Awaits",
  seats: "Best deals guaranteed",
  route: "Vietnam all-inclusive",
  image:
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dream-destinations-10/artifacts/02163d8002043c5a_WhatsApp%20Image%202026-10-22%20at%2014.49.21%20%281%29.jpeg"
}];


export const whyChooseItems = [
{
  title: "Curated Travel Experiences",
  description: "Every itinerary is designed around your style, pace, and preferences."
},
{
  title: "Handpicked Hotels",
  description: "We work with top-rated luxury and boutique stays across destinations."
},
{
  title: "24/7 Travel Support",
  description: "Our travel concierge team is available anytime during your journey."
},
{
  title: "Best Price Guarantee",
  description: "Premium value with transparent pricing and thoughtfully bundled inclusions."
}];


export const testimonials = [
{
  name: "Aarav & Meera",
  text: "Our Maldives honeymoon felt effortless and magical. Every detail was flawless."
},
{
  name: "Riya S.",
  text: "From visa guidance to luxury stays in Europe, this was the smoothest trip I've ever taken."
},
{
  name: "Karan P.",
  text: "They understood exactly what we wanted and built a perfect Thailand family vacation."
},
{
  name: "Nidhi & Arjun",
  text: "The Dubai itinerary was premium, personalized, and packed with memorable experiences."
}];